<template>
  <div v-if="isAccountCreatedOnThisView" class="text-xs text-grey-600 break-words">
    By continuing you are creating an account and accepting our
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/terms-user"
      @click="$emit('termsAndConditionsClick')"
    > Terms and Conditions</a>,
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/privacy-policy"
      @click="$emit('privacyPolicyClick')"
    >Privacy Policy</a> and
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://support.tagvenue.com/hc/en-gb/articles/360018095798-What-is-the-Tagvenue-cancellation-and-refund-policy-"
      @click="$emit('cancellationPolicyClick')"
    >Cancellation and Refund Policy.</a>
  </div>
  <div v-else-if="isUserOnBookingRequestForm" class="text-xs text-grey-600 break-words">
    By selecting the button below, I agree to the
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/terms-user"
      @click="$emit('termsAndConditionsClick')"
    > Terms and Conditions</a>,
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/privacy-policy"
      @click="$emit('privacyPolicyClick')"
    >Privacy Policy</a>,
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://support.tagvenue.com/hc/en-gb/articles/360018095798-What-is-the-Tagvenue-cancellation-and-refund-policy-"
      @click="$emit('cancellationPolicyClick')"
    >Cancellation and Refund Policy</a> and that Tagvenue can charge my payment method if I’m responsible for damage.
  </div>
  <div v-else-if="isUserOnCustomOfferForm" class="text-xs text-grey-600 break-words">
    By selecting Accept offer, I agree to the
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/terms-user"
      @click="$emit('termsAndConditionsClick')"
    > Terms and Conditions</a>,
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/privacy-policy"
      @click="$emit('privacyPolicyClick')"
    >Privacy Policy</a>,
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://support.tagvenue.com/hc/en-gb/articles/360018095798-What-is-the-Tagvenue-cancellation-and-refund-policy-"
      @click="$emit('cancellationPolicyClick')"
    >Cancellation and Refund Policy</a> and that Tagvenue can charge my payment method if I’m responsible for damage.
  </div>
  <div v-else-if="isUserOnReviewBookingUpdateForm" class="text-xs text-grey-600 break-words">
    By selecting Accept updated offer, I agree to the
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/terms-user"
      @click="$emit('termsAndConditionsClick')"
    > Terms and Conditions</a>,
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/privacy-policy"
      @click="$emit('privacyPolicyClick')"
    >Privacy Policy</a>,
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://support.tagvenue.com/hc/en-gb/articles/360018095798-What-is-the-Tagvenue-cancellation-and-refund-policy-"
      @click="$emit('cancellationPolicyClick')"
    >Cancellation and Refund Policy</a> and that Tagvenue can charge my payment method if I’m responsible for damage.
  </div>
  <div v-else class="text-xs text-grey-600 break-words">
    By continuing you are accepting our
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/terms-user"
      @click="$emit('termsAndConditionsClick')"
    > Terms and Conditions</a>,
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://www.tagvenue.com/page/privacy-policy"
      @click="$emit('privacyPolicyClick')"
    >Privacy Policy</a> and
    <a
      class="text-grey-600 font-normal underline whitespace-nowrap"
      target="_blank"
      href="https://support.tagvenue.com/hc/en-gb/articles/360018095798-What-is-the-Tagvenue-cancellation-and-refund-policy-"
      @click="$emit('cancellationPolicyClick')"
    >Cancellation and Refund Policy.</a>
  </div>
</template>

<script>
export default {
  name: 'LegalNotice',
  emits: ['termsAndConditionsClick', 'privacyPolicyClick', 'cancellationPolicyClick'],
  props: {
    isAccountCreatedOnThisView: {
      type: Boolean,
      default: false,
    },
    isUserOnBookingRequestForm: {
      type: Boolean,
      default: false,
    },
    isUserOnCustomOfferForm: {
      type: Boolean,
      default: false,
    },
    isUserOnReviewBookingUpdateForm: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-underline-offset: 2px;
}
</style>
